import React from "react";
import "./TopStatusStrip.css";

function TopStatusStrip({ left, center, right, className = "" }) {
    return (
        <div className={`top-strip ${className}`} role="status" aria-live="polite">
            <div className="top-strip__zone top-strip__left">{left}</div>
            <div className="top-strip__zone top-strip__center">{center}</div>
            <div className="top-strip__zone top-strip__right">{right}</div>
        </div>
    );
}

export default TopStatusStrip;
